import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import Carousel from '@carvana/carousel';
import { getMediaQuery } from '@carvana/showroom-theme';
import { Video } from '../../helpers/video/index';

export const CarouselItem = styled.div`
  background-color: ${(props) => props.theme.color.neutral.v100};
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  display: flex;
  width: 200px;
  height: 110px;
  flex-direction: column;
  font-size: 1rem;
  justify-content: flex-start;
  border-radius: 4px;
`;

export const VideoWrapper = styled(Video)`
  width: 332px;
  height: 187px;
`;

export const VideoTitleCountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5rem 1rem 0.5rem;

  ${(props) =>
    !props.showMoreLink &&
    css`
      padding-top: 1rem;
    `};
`;

export const VideoTitle = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: 700;
`;

export const VideoCount = styled.div`
  color: ${(props) => props.theme.color.neutral.v400};
  font-size: 0.875rem;
`;

export const VideoLearnMoreLink = styled(Link)`
  text-decoration: underline;
  padding-left: 1rem;
  color: ${(props) => props.theme.color.primary.v200};

  &:hover {
    color: ${(props) => props.theme.color.primary.v200};
  }
`;

export const CarouselWrapper = styled(Carousel)`
  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    margin-left: -10px;
  }
`;
